export const KEY_SEPARATOR = '.#.';
